<app-header></app-header>

<!-- Page title section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg')">
    <div class="bg-dark-05">
        <div class="container text-center z-index-1">
            <h1 class="fw-bold uppercase letter-spacing-1 m-0">Blog Standard</h1>
        </div><!-- end container -->
    </div>
</div>
<!-- end Page title section -->

<!-- Blog section  -->
<div class="section">
  <div class="container">
    <div class="row g-5">

      <!-- Blog Posts -->
      <div class="col-12 col-lg-8">
        <div class="mb-5" *ngFor="let post of blogPosts">
          <div class="img-link-box">
            <a [href]="post.link">
              <img [src]="post.image" [alt]="post.title">
            </a>
          </div>
          <div class="mt-4">
            <div class="d-flex justify-content-between mb-2">
              <div class="d-inline-flex">
                <a class="font-family-poppins font-small fw-medium uppercase" href="#.">{{ post.category }}</a>
              </div>
              <div class="d-inline-flex">
                <span class="font-small">{{ post.date }}</span>
              </div>
            </div>
            <h4><a class="text-link-1 text-color-theme" [href]="post.link">{{ post.title }}</a></h4>
            <p>{{ post.description }}</p>
            <div class="mt-3">
              <a class="button-text-1" [href]="post.link">Read More</a>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <nav>
          <ul class="pagination justify-content-center mt-5">
            <li class="page-item"><a class="page-link" href="#.">&laquo;</a></li>
            <li class="page-item active"><a class="page-link" href="#.">1</a></li>
            <li class="page-item"><a class="page-link" href="#.">2</a></li>
            <li class="page-item"><a class="page-link" href="#.">3</a></li>
            <li class="page-item"><a class="page-link" href="#.">&raquo;</a></li>
          </ul>
        </nav>
      </div>

      <!-- Sidebar -->
      <div class="col-12 col-lg-4 d-none d-lg-block">
        <!-- About Me -->
        <div class="border p-4 mb-4 text-center">
          <h6 class="font-small fw-medium uppercase mb-4 text-color-theme">About Me</h6>
          <img class="img-mask-avatar-md mb-3" src="assets/images/about/about-me-1.jpg" alt="about-me">
          <p>Aenean massa. Cum sociis natoque penatibus...</p>
          <ul class="list-inline mt-3">
            <li><a href="/"><i class="bi bi-facebook"></i></a></li>
            <li><a href="/"><i class="bi bi-twitter-x"></i></a></li>
            <li><a href="/"><i class="bi bi-pinterest"></i></a></li>
            <li><a href="/"><i class="bi bi-instagram"></i></a></li>
          </ul>
        </div>

        <!-- Categories -->
        <div class="border p-4 mb-4">
          <h6 class="font-small fw-medium uppercase mb-4 text-center text-color-theme">Categories</h6>
          <ul class="list-unstyled">
            <li class="pb-2 border-bottom" *ngFor="let cat of categories">
              <a class="d-flex justify-content-between" href="#.">{{ cat.name }} <span>{{ cat.count }}</span></a>
            </li>
          </ul>
        </div>

        <!-- Popular Posts -->
        <div class="border p-4 mb-4">
          <h6 class="font-small fw-medium uppercase mb-4 text-center text-color-theme">Popular Posts</h6>
          <div class="d-flex align-items-center mb-3" *ngFor="let p of popularPosts">
            <a href="blog-grid.html">
              <img [src]="p.image" [alt]="p.title">
            </a>
            <div class="ps-3">
              <h6 class="fw-normal mb-0"><a class="text-link-1" href="blog-grid.html">{{ p.title }}</a></h6>
              <span class="font-small">{{ p.date }}</span>
            </div>
          </div>
        </div>

        <!-- Tags -->
        <div class="border p-4 mb-4">
          <h6 class="font-small fw-medium uppercase mb-4 text-center text-color-theme">Tags</h6>
          <ul class="list-inline">
            <li *ngFor="let tag of tags"><a class="button-text-1" href="#.">{{ tag }}</a></li>
          </ul>
        </div>

        <!-- Follow Us -->
        <div class="border p-4 mb-4 text-center">
          <h6 class="font-small fw-medium uppercase mb-4 text-color-theme">Follow on</h6>
          <ul class="list-inline">
            <li><a href="/"><i class="bi bi-facebook"></i></a></li>
            <li><a href="/"><i class="bi bi-twitter-x"></i></a></li>
            <li><a href="/"><i class="bi bi-pinterest"></i></a></li>
            <li><a href="/"><i class="bi bi-behance"></i></a></li>
            <li><a href="/"><i class="bi bi-instagram"></i></a></li>
          </ul>
        </div>
      </div>
      <!-- End Sidebar -->
    </div>
  </div>
</div>
<!-- end Blog section -->